import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AnalyticsEvent, InternalAnalyticsService } from '../../core/internal-analytics.service';
import { UserService } from '../../core/user/user.service';

@Component({
    selector: 'rosie-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit {
    // State management
    isLoading = true;
    isSubmitting = false;
    hasError = false;
    isSuccess = false;
    isVisible = true;
    referralSourceControl = new FormControl();

    selectedOptionLabel = '';
    options: any[] = [];

    constructor(
        private user: UserService,
        private analytics: InternalAnalyticsService
    ) { }

    ngOnInit(): void {
        this.setOptions();
    }

    get showFeedbackSection(): boolean {
        return this.isVisible;
    }

    get showForm(): boolean {
        return !this.isSubmitting && !this.isSuccess;
    }

    selectReferralSource(option: any): void {
        this.referralSourceControl.setValue(option.value);
        this.selectedOptionLabel = option.label;
    }

    submitReferralSource(): void {
        if (!this.referralSourceControl.value || this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;
        this.hasError = false;

        const payload = {
            meta: {
                referralSource: this.referralSourceControl.value
            }
        };

        this.user.updateUser(payload).subscribe({
            next: () => {
                this.isSubmitting = false;
                this.isSuccess = true;

                setTimeout(() => this.isVisible = false, 5000);
            },
            error: () => {
                this.hasError = true;
                this.isSubmitting = false;
            }
        });
    }

    private setOptions(): void {
        this.options = [
            { value: 'advertisement', label: 'Saw an advertisement' },
            { value: 'referred_by_friend', label: 'Referred by a friend' },
            { value: 'search_engine', label: 'Search engine (Google, etc.)' },
            { value: 'ai_app', label: 'ChatGPT or similar AI app' },
            { value: 'podcast', label: 'On a podcast' },
            { value: 'facebook_group', label: 'Facebook industry group' }
        ];
    }
}
